export const mistralMandatoryOptions = [
    {
        key: "MistralConversations",
        name: "MistralConversations",
        title: "Mistral conversations",
        description: "All conversations you’ve had in the Mistral chatbot.",
        optionPlatform: "mistral",
        essential: true,         
        payment: "+$5.0",
        type: "standard",
        parent: null,
        use: null,
        warning: "These conversations may contain sensitive personal information. We strongly recommend checking the archive before donation to better understand what you are donating."
    },

]; 

export const mistralOptionalOptions = [
    {   
        key: "MistralUploadedFiles", 
        name: "MistralUploadedFiles",
        title: "Mistral uploaded files",
        description: "All files you’ve uploaded to or generated on Mistral Le Chat. This includes file details and associated metadata if any.",
        optionPlatform: "mistral",
        essential: false,         
        payment: "+$2.0",
        type: "standard",
        parent: null, 
        use: null,
        warning: "These files may contain sensitive personal information. We strongly recommend checking the archive before donation to better understand what you are donating."
    }
]; 

export const mistralExcludedOptions  = [
    {

    }


]; 